<template lang="pug">
b-modal#resetPasswordAffiliate(
  ref="resetPasswordAffiliate"
  :title="$t('ui.combine.reset_password')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled)
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.account_id.$dirty"
        :error="$v.account_id.$error"
        v-model.trim.lazy="$v.account_id.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
    b-form-group(:label="$t('ui.combine.new_password')")
      DebounceInput(
        size="sm"
        ref="new_password"
        type="password"
        :dirty="$v.new_password.$dirty"
        :error="$v.new_password.$error"
        v-model.trim.lazy="$v.new_password.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.new_password" :name="$t('ui.combine.new_password')")
    b-form-group(:label="$t('ui.combine.confirm_password')")
      DebounceInput(
        size="sm"
        type="password"
        :dirty="$v.new_password_confirm.$dirty"
        :error="$v.new_password_confirm.$error"
        v-model.trim.lazy="$v.new_password_confirm.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.new_password_confirm" :name="$t('ui.combine.confirm_password')", :name2="$t('ui.combine.new_password')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      account_id: "",
      new_password: "",
      new_password_confirm: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
   },
  validations: {
    account_id: {
      required
    },
    new_password: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    new_password_confirm: {
      required,
      sameAs: sameAs("new_password")
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.passwordResetAffUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.isOperator ? this.accountID : this.operatorID,
          login_id: this.account_id,
          new_password: this.new_password
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.resetPasswordAffiliate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "reset_password", this.feedback.status);
                  this.$refs.resetPasswordAffiliate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.new_password = '';
      this.new_password_confirm = '';
      this.$refs.new_password.$el.focus();
    }
  }
};
</script>
